import React from "react";
import PropTypes from "prop-types";
import { withState } from "recompose";
import classnames from "classnames";
import styles from "./Thumbnail.scss";

function Thumbnail({
  src,
  onHover,
  isThumbnailOnHover,
  toggleHoverThumbnail,
  icon,
  className,
  title,
}) {
  const handleOnHover = value => {
    toggleHoverThumbnail(() => value);
    return onHover(!isThumbnailOnHover);
  };

  return (
    <div
      className={classnames(
        "wbkv9-Thumbnail",
        styles.Thumbnail,
        icon && styles.icon,
        styles[className]
      )}
      onMouseEnter={() => handleOnHover(true)}
      onMouseLeave={() => handleOnHover(false)}>
      <aside className={classnames("wbkv9-Thumbnail-aside", "row center-xs", styles.thumbnail)}>
        <div className={classnames("wbkv9-Thumbnail-imgContainer", styles.imgContainer)}>
          <img src={src} alt={title || "thumbnail"} />
        </div>
      </aside>
    </div>
  );
}

Thumbnail.propTypes = {
  src: PropTypes.string.isRequired,
  onHover: PropTypes.func,
  title: PropTypes.string,
};
const enhance = withState("isThumbnailOnHover", "toggleHoverThumbnail", false);
export default enhance(Thumbnail);
